export const styles = {
  container: 'flex-1 flex flex-col px-4 py-6 space-y-4',

  // Container principal dos detalhes
  detailContainer: 'space-y-4',

  // Header do cierre
  headerCard: 'bg-white rounded-xl border border-gray-200 shadow-sm p-6',
  headerTitle:
    'flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-2',
  title: 'text-2xl font-bold text-gray-900',
  headerSubtitle: 'text-sm text-gray-500',

  // Status badge
  statusBadge:
    'inline-flex items-center px-3 py-1 rounded-full text-sm font-medium',
  statusClosed: 'bg-green-100 text-green-800',
  statusOpen: 'bg-yellow-100 text-yellow-800',
  statusCancelled: 'bg-red-100 text-red-800',
  statusInProgress: 'bg-blue-100 text-blue-800',

  // Cards de informação
  infoCard: 'bg-white rounded-xl border border-gray-200 shadow-sm p-6',
  additionalCard: 'bg-white rounded-xl border border-gray-200 shadow-sm p-6',
  cardTitle:
    'text-lg font-semibold text-gray-900 mb-4 pb-2 border-b border-gray-100',

  // Grid de informações
  infoGrid: 'grid grid-cols-1 sm:grid-cols-2 gap-4',
  infoItem: 'flex flex-col space-y-1',
  infoLabel: 'text-sm font-medium text-gray-600',
  infoValue: 'text-sm font-semibold text-gray-900',
  infoValueAmount: 'text-lg font-bold text-green-600',

  // Container de ações
  actionsContainer: 'flex flex-col sm:flex-row gap-3 mt-6',
  printButton:
    'h-16 w-full flex items-center justify-center bg-blue-600 text-white px-8 rounded-xl text-base font-semibold hover:bg-blue-700 transition-all duration-150 shadow-md hover:shadow-lg',
  backButton:
    'h-16 w-full flex items-center justify-center bg-black text-white px-8 rounded-xl text-base font-semibold hover:bg-gray-900 transition-all duration-150 shadow-md hover:shadow-lg',

  // Responsividade para impressão
  printStyles: `
    @media print {
      .no-print {
        display: none !important;
      }
      
      .print-break {
        page-break-before: always;
      }
      
      .print-container {
        max-width: none !important;
        margin: 0 !important;
        padding: 20px !important;
      }
    }
  `,
} as const

export const texts = {
  title: 'Detalle cierre',
  closureId: 'ID del Cierre',
  closureInfo: 'Información del Cierre',
  additionalInfo: 'Información Adicional',

  // Campos
  date: 'Fecha',
  amount: 'Monto',
  responsible: 'Responsable',
  route: 'Ruta',
  closingTime: 'Hora cierre',
  company: 'Empresa',
  creationDate: 'Fecha de creación',
  lastUpdate: 'Última actualización',

  // Status
  statusClosed: 'Cerrada',
  statusOpen: 'Abierta',
  statusCancelled: 'Cancelada',
  statusInProgress: 'En Progreso',

  // Valores padrão
  notAvailable: 'No disponible',

  // Ações
  print: 'Imprimir',
  goBack: 'Regresar',
} as const
